import MessageFormValidate from "components/shared-components/MessageFormValidate";
import React from "react";
import Flatpickr from "react-flatpickr";
import { Controller } from "react-hook-form";
import NumberFormat from "react-number-format";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import {
  Col,
  FormGroup,
  Input,
  Label,
  Row,
  UncontrolledTooltip,
} from "reactstrap";
export const formValidate = (errors, touched, field) => {
  if (field in errors) {
    // return "is-invalid";
    return "";
  } else {
    if (Object.keys(errors).length === 0 && Object.keys(touched).length === 0) {
      return "";
    } else if (field in touched) {
      // return "is-invalid";
      return "";
    } else {
      return "";
    }
  }
};

export const formConvertErrorMessage = (message = "", t, expandMess = "") => {
  // If [t] not a Function
  if (typeof t !== "function") {
    return message;
  }

  let result = message;
  const msgLowerCase = message.toLowerCase();

  if (msgLowerCase.includes("already been taken")) {
    result = t("common:validate.msg_duplicate");
  } else if (msgLowerCase.includes("please correct your data")) {
    result = t("common:validate.msg_correct_data");
  } else if (msgLowerCase.includes("effective time must be greater than")) {
    result = t("common:validate.msg_effective_greater");
  }

  return `${expandMess} ${result} `;
};

export const formValidateObject = (errors, touched, fieldObject, field) => {
  //   console.log("errors", errors);
  //   console.log("touched", touched);
  //   console.log("field", field);
  if (errors[fieldObject] && errors[fieldObject][field]) {
    return "is-invalid";
  } else {
    if (Object.keys(errors).length === 0 && Object.keys(touched).length === 0) {
      return "";
    } else if (fieldObject in touched) {
      if (touched[fieldObject] && touched[fieldObject][field]) {
        return "is-valid";
      }
      return "";
    } else {
      return "";
    }
  }
};

export const formValidateFieldArray = (
  errors,
  touched,
  fieldArray,
  index,
  fieldChild
) => {
  if (
    errors[fieldArray] &&
    errors[fieldArray][index] &&
    errors[fieldArray][index][fieldChild]
  ) {
    return "is-invalid";
  } else {
    if (Object.keys(errors).length === 0 && Object.keys(touched).length === 0) {
      return "";
    } else if (fieldArray in touched) {
      if (
        touched[fieldArray][index] &&
        touched[fieldArray][index][fieldChild]
      ) {
        // return "is-valid";
        return "";
      }
      return "";
    } else {
      return "";
    }
  }
};

// Reack hook form useFieldArray
export const generateInputFieldArray = (
  label,
  isRequire,
  inputType,
  errors,
  touched,
  fieldArray,
  index,
  fieldChild,
  placeholder,
  register,
  disabled,
  setInputValueChange,
  control,
  isThousandSeparator = false,
  allowNegative = false,
  maxValue
) => {
  const uniqueId = `${fieldArray}-${index}-${fieldChild}`;
  return (
    <React.Fragment>
      {/* <Label htmlFor={fieldChild}>
        {label}
        {isRequire && <span className="text-danger"> (*)</span>}
      </Label> */}
      {inputType === "textarea" ? (
        <textarea
          disabled={disabled}
          id={uniqueId}
          type={inputType}
          className={`form-control ${formValidateFieldArray(
            errors,
            touched,
            fieldArray,
            index,
            fieldChild
          )}`}
          placeholder={disabled ? "" : placeholder}
          {...register(`${fieldArray}.${index}.${fieldChild}`, {
            // onBlur: e => onBlurHandle(e, fieldArray, index, fieldChild),
          })}
        />
      ) : isThousandSeparator ? (
        <Controller
          control={control}
          name={`${fieldArray}.${index}.${fieldChild}`}
          render={({ field: { onChange, name, value } }) => (
            <NumberFormat
              thousandSeparator={true}
              disabled={disabled}
              id={uniqueId}
              //   isAllowed={values => {
              //     const { floatValue } = values;
              //     return floatValue >= 5 && floatValue <= 10000;
              //   }}
              allowNegative={allowNegative}
              className={`form-control ${formValidateFieldArray(
                errors,
                touched,
                fieldArray,
                index,
                fieldChild
              )}`}
              value={value}
              onValueChange={v => {
                onChange(Number(v.value));
                setInputValueChange &&
                  setInputValueChange({ fieldArray, index, fieldChild });
              }}
            />
          )}
        />
      ) : (
        <input
          disabled={disabled}
          id={uniqueId}
          type={inputType}
          className={`form-control ${formValidateFieldArray(
            errors,
            touched,
            fieldArray,
            index,
            fieldChild
          )}`}
          //   placeholder={disabled ? "" : placeholder}
          {...register(`${fieldArray}.${index}.${fieldChild}`, {
            // onBlur: e => {
            //   onBlurHandle && onBlurHandle(e, fieldArray, index, fieldChild);
            // },
          })}
        />
      )}
      {errors[fieldArray] &&
        errors[fieldArray][index] &&
        errors[fieldArray][index][fieldChild] && (
          <UncontrolledTooltip
            // style={{
            //   color: "red",
            //   background: "white",
            //   border: "1px solid red",
            // }}
            placement="right"
            target={uniqueId}
          >
            {errors[fieldArray][index][fieldChild].message}
          </UncontrolledTooltip>
        )}
    </React.Fragment>
  );
};

export const generateSelectFieldArray = (
  watch,
  label,
  isRequire,
  errors,
  fieldArray,
  index,
  fieldChild,
  placeholder,
  disabled,
  control,
  options,
  onChangeHandle,
  menuPlacementSetting = "auto",
  allowCreate = false
) => {
  const uniqueId = `${fieldArray}-${index}-${fieldChild}`;
  return (
    <React.Fragment>
      {/* <Label htmlFor={fieldChild}>  
        {label}
        {isRequire && <span className="text-danger"> (*)</span>}
      </Label> */}
      <Controller
        control={control}
        name={`${fieldArray}.${index}.${fieldChild}`}
        render={({ field }) =>
          !allowCreate ? ( // @ts-ignore
            <Select
              {...field}
              id={uniqueId}
              onChange={data => {
                field.onChange(data);
                onChangeHandle && onChangeHandle(fieldArray, index, fieldChild);
              }}
              isOptionSelected={(option, selectValue) =>
                selectValue.some(i => i === option)
              }
              menuPlacement={menuPlacementSetting}
              isDisabled={disabled}
              placeholder={disabled ? "" : placeholder}
              options={options}
              classNamePrefix="select2-selection"
            />
          ) : fieldChild === "tsuat" ? (
            <CreatableSelect
              {...field}
              id={uniqueId}
              isValidNewOption={(inputValue, selectValue) => {
                return inputValue !== "" && inputValue < 100;
              }}
              onChange={data => {
                if (data.__isNew__) {
                  data.label =
                    "KHAC:" + String(data.label).padStart(2, "0") + ".00%";
                }
                field.onChange(data);
                onChangeHandle && onChangeHandle(fieldArray, index, fieldChild);
              }}
              isOptionSelected={(option, selectValue) =>
                selectValue.some(i => i === option)
              }
              onKeyDown={evt => {
                var ASCIICode = evt.which ? evt.which : evt.keyCode;
                if (ASCIICode > 31 && (ASCIICode < 48 || ASCIICode > 57))
                  evt.preventDefault();
              }}
              menuPlacement={menuPlacementSetting}
              isDisabled={disabled}
              placeholder={disabled ? "" : placeholder}
              options={options}
              classNamePrefix="select2-selection"
            />
          ) : (
            <CreatableSelect
              {...field}
              id={uniqueId}
              onChange={data => {
                field.onChange(data);
                onChangeHandle && onChangeHandle(fieldArray, index, fieldChild);
              }}
              isOptionSelected={(option, selectValue) =>
                selectValue.some(i => i === option)
              }
              isClearable={true}
              menuPlacement={menuPlacementSetting}
              isDisabled={disabled}
              placeholder={disabled ? "" : placeholder}
              options={options}
              classNamePrefix="select2-selection"
            />
          )
        }
      />
      {/* {errors[fieldArray] &&
        errors[fieldArray][index] &&
        errors[fieldArray][index][fieldChild] && ( */}
      <UncontrolledTooltip
        // style={{
        //   color: "red",
        //   background: "white",
        //   border: "1px solid red",
        // }}
        placement="right"
        target={uniqueId}
      >
        {errors[fieldArray] &&
        errors[fieldArray][index] &&
        errors[fieldArray][index][fieldChild]
          ? errors[fieldArray][index][fieldChild].message
          : watch(fieldArray)[index][fieldChild]?.label}
      </UncontrolledTooltip>
    </React.Fragment>
  );
};

export const generateDateFieldArray = (
  labelFrom,
  labelTo,
  isRequire,
  errors,
  fieldArray,
  index,
  fieldChild,
  placeholder,
  disabled,
  control,
  options
) => {
  return (
    <React.Fragment>
      {/* <Label htmlFor={fieldChild}>
        {labelFrom}
        {labelFrom && isRequire && <span className="text-danger"> (*)</span>}
        {labelTo && `- ${labelTo}`}
        {labelTo && isRequire && <span className="text-danger"> (*)</span>}
      </Label> */}
      <Controller
        control={control}
        name={`${fieldArray}.${index}.${fieldChild}`}
        render={({ field }) => (
          <Flatpickr
            {...field}
            disabled={disabled}
            className="form-control d-block Flatpickr__Input"
            placeholder={disabled ? "" : placeholder}
            options={options}
          />
        )}
      />
      {errors[fieldArray] &&
        errors[fieldArray][index] &&
        errors[fieldArray][index][fieldChild] && (
          <MessageFormValidate
            error={errors[fieldArray][index][fieldChild].message}
          />
        )}
    </React.Fragment>
  );
};

export const EXTRA_BUTTON = {
  LOAD_TAX: "LOAD_TAX",
  SEARCH_CUSTOMER: "SEARCH_CUSTOMER",
};

// Reack hook form
export const generateInputField = (
  label,
  isRequire,
  inputType,
  errors,
  touched,
  fieldName,
  placeholder,
  register,
  disabled,
  widthLabel,
  control,
  isThousandSeparator = false,
  isTaxCode = false,
  allowNegative = false,
  onChangeHandle,
  extraComponent = {},
  isKHHD = false,
  invoiceSymbolList = [],
  khhdonDefault = ""
) => {
  return (
    <React.Fragment>
      <Label htmlFor={fieldName} style={{ minWidth: widthLabel }}>
        {label}
        {isRequire && <span className="text-danger"> (*)</span>}
      </Label>
      {inputType === "textarea" ? (
        <textarea
          disabled={disabled}
          type={inputType}
          className={`form-control ${formValidate(errors, touched, fieldName)}`}
          placeholder={disabled ? "" : placeholder}
          {...register(`${fieldName}`)}
        />
      ) : isThousandSeparator ? (
        <Controller
          control={control}
          name={`${fieldName}`}
          render={({ field: { onChange, name, value } }) => (
            <NumberFormat
              thousandSeparator={true}
              className={`form-control ${formValidate(
                errors,
                touched,
                fieldName
              )}`}
              allowNegative={allowNegative}
              disabled={disabled}
              value={value}
              onValueChange={v => {
                onChange(v.value);
              }}
            />
          )}
        />
      ) : isTaxCode ? (
        <React.Fragment>
          <div className="d-flex align-items-center gap-1">
            {/* <Controller
              control={control}
              name={`${fieldName}`}
              render={({ field: { onChange, name, value } }) => (
                <NumberFormat
                  // format="##########-###"
                  style={{ width: "250px" }}
                  allowEmptyFormatting={false}
                  placeholder={disabled ? "" : placeholder}
                  // mask="_"
                  allowNegative={allowNegative}
                  className={`form-control ${formValidate(
                    errors,
                    touched,
                    fieldName
                  )}`}
                  disabled={disabled}
                  value={value}
                  onValueChange={v => {
                    let finalValue = formatTaxCode(v.value);
                    onChange(finalValue);
                    onChangeHandle && onChangeHandle(finalValue, fieldName);
                  }}
                />
              )}
            /> */}
            <input
              disabled={disabled}
              type={inputType}
              autoComplete="off"
              className={`form-control ${formValidate(
                errors,
                touched,
                fieldName
              )}`}
              placeholder={disabled ? "" : placeholder}
              {...register(`${fieldName}`)}
            />
            {extraComponent && extraComponent[EXTRA_BUTTON.LOAD_TAX]}
          </div>
        </React.Fragment>
      ) : isKHHD ? (
        <React.Fragment>
          <Controller
            control={control}
            name={`${fieldName}`}
            render={({ field }) => (
              <React.Fragment>
                <Row>
                  <Col className="col-auto pe-0">
                    <span className="input-group-text">{khhdonDefault}</span>
                  </Col>
                  <Col className="ps-0">
                    <Select
                      {...field}
                      isDisabled={disabled}
                      placeholder={placeholder}
                      options={
                        invoiceSymbolList && invoiceSymbolList.length > 0
                          ? invoiceSymbolList.map(item => ({
                              value: item.id,
                              label: item.khhdon,
                            }))
                          : []
                      }
                      classNamePrefix="select2-selection"
                    />
                  </Col>
                </Row>
              </React.Fragment>
            )}
          />
          {/* <div className="d-flex align-items-center gap-1">
            <Controller
              control={control}
              name={`${fieldName}`}
              render={({ field: { onChange, name, value } }) => (
                // A, B, C, D, E, G, H, K, L, M, N, P, Q, R, S, T, U, V, X, Y
                <InputMask
                  mask="******"
                  value={value}
                  disabled={disabled}
                  className={`form-control ${formValidate(
                    errors,
                    touched,
                    fieldName
                  )}`}
                  onKeyDown={e => {
                    const charAllow = [
                      "A",
                      "B",
                      "C",
                      "D",
                      "E",
                      "G",
                      "H",
                      "K",
                      "L",
                      "M",
                      "N",
                      "P",
                      "Q",
                      "R",
                      "S",
                      "T",
                      "U",
                      "V",
                      "X",
                      "Y",
                    ];
                    if (
                      value.replace("_", "").length === 4 &&
                      (e.keyCode === 8 || e.keyCode === 46)
                    ) {
                      e.preventDefault();
                    } else {
                      if (
                        charAllow.indexOf(e.key.toUpperCase()) === -1 &&
                        e.keyCode !== 8
                      ) {
                        e.preventDefault();
                      }
                    }
                  }}
                  onChange={v => {
                    onChange(v.target.value.replace("_", "").toUpperCase());
                  }}
                ></InputMask>
              )}
            />
          </div> */}
        </React.Fragment>
      ) : (
        <React.Fragment>
          <div className="d-flex align-items-center gap-1">
            <input
              disabled={disabled}
              type={inputType}
              className={`form-control ${formValidate(
                errors,
                touched,
                fieldName
              )}`}
              placeholder={disabled ? "" : placeholder}
              {...register(`${fieldName}`)}
            />
            {fieldName === "nmua_ten" &&
              extraComponent &&
              extraComponent[EXTRA_BUTTON.SEARCH_CUSTOMER]}
          </div>
        </React.Fragment>
      )}
      {errors[fieldName] && (
        <MessageFormValidate error={errors[fieldName].message} />
      )}
    </React.Fragment>
  );
};

export const generateSelectField = (
  label,
  isRequire,
  errors,
  fieldKey,
  placeholder,
  disabled,
  control,
  options,
  menuPlacementSetting = "auto",
  onChangeHandle,
  isLoading = false
) => {
  return (
    <React.Fragment>
      <Label htmlFor={fieldKey}>
        {label}
        {isRequire && <span className="text-danger"> (*)</span>}
      </Label>
      <Controller
        control={control}
        name={fieldKey}
        render={({ field }) => (
          <Select
            {...field}
            menuPlacement={menuPlacementSetting}
            isLoading={isLoading}
            onChange={data => {
              field.onChange(data);
              onChangeHandle && onChangeHandle(data, fieldKey);
            }}
            isDisabled={disabled}
            placeholder={disabled ? "" : placeholder}
            options={options}
            classNamePrefix="select2-selection"
          />
        )}
      />

      {errors[fieldKey] && (
        <MessageFormValidate error={errors[fieldKey].message} />
      )}
    </React.Fragment>
  );
};

export const generateDateField = (
  labelFrom,
  labelTo,
  isRequire,
  errors,
  field,
  placeholder,
  disabled,
  control,
  options
) => {
  return (
    <React.Fragment>
      <Label htmlFor={field}>
        {labelFrom}
        {labelFrom && isRequire && <span className="text-danger"> (*)</span>}
        {labelTo && `- ${labelTo}`}
        {labelTo && isRequire && <span className="text-danger"> (*)</span>}
      </Label>
      <Controller
        control={control}
        name={field}
        render={({ field }) => (
          <Flatpickr
            {...field}
            disabled={disabled}
            className="form-control d-block Flatpickr__Input"
            placeholder={disabled ? "" : placeholder}
            options={options}
          />
        )}
      />
      {errors[field] && <MessageFormValidate error={errors[field].message} />}
    </React.Fragment>
  );
};

export const generateCheckboxField = (
  labelFrom,
  labelTo,
  isRequire,
  errors,
  field,
  placeholder,
  disabled,
  control,
  options
) => {
  return (
    <React.Fragment>
      <Label htmlFor={field}>
        {labelFrom}
        {labelFrom && isRequire && <span className="text-danger"> (*)</span>}
        {labelTo && `- ${labelTo}`}
        {labelTo && isRequire && <span className="text-danger"> (*)</span>}
      </Label>
      <Controller
        control={control}
        name={field}
        render={({ field }) => (
          <Flatpickr
            {...field}
            disabled={disabled}
            className="form-control d-block Flatpickr__Input"
            placeholder={disabled ? "" : placeholder}
            options={options}
          />
        )}
      />
      {errors[field] && <MessageFormValidate error={errors[field].message} />}
    </React.Fragment>
  );
};

// Reack hook form object
export const generateInputFieldObject = (
  label,
  isRequire,
  inputType,
  errors,
  touched,
  fieldObject,
  field,
  placeholder,
  register,
  disabled
) => {
  return (
    <React.Fragment>
      <Label htmlFor={`${fieldObject}.${field}`}>
        {label}
        {isRequire && <span className="text-danger"> (*)</span>}
      </Label>
      {inputType === "textarea" ? (
        <textarea
          disabled={disabled}
          type={inputType}
          className={`form-control ${formValidateObject(
            errors,
            touched,
            fieldObject,
            field
          )}`}
          placeholder={disabled ? "" : placeholder}
          {...register(`${fieldObject}.${field}`)}
        />
      ) : (
        <input
          disabled={disabled}
          type={inputType}
          className={`form-control ${formValidateObject(
            errors,
            touched,
            fieldObject,
            field
          )}`}
          placeholder={disabled ? "" : placeholder}
          {...register(`${fieldObject}.${field}`)}
        />
      )}
      {errors[fieldObject] && errors[fieldObject][field] && (
        <MessageFormValidate error={errors[fieldObject][field].message} />
      )}
    </React.Fragment>
  );
};

export const generateSelectFieldObject = (
  label,
  isRequire,
  errors,
  fieldObject,
  field,
  placeholder,
  disabled,
  control,
  options,
  menuPlacementSetting = "auto"
) => {
  return (
    <React.Fragment>
      <Label htmlFor={`${fieldObject}.${field}`}>
        {label}
        {isRequire && <span className="text-danger"> (*)</span>}
      </Label>
      <Controller
        control={control}
        name={`${fieldObject}.${field}`}
        render={({ field }) => (
          <Select
            {...field}
            menuPlacement={menuPlacementSetting}
            isDisabled={disabled}
            placeholder={disabled ? "" : placeholder}
            options={options}
            classNamePrefix="select2-selection"
          />
        )}
      />

      {errors[fieldObject] && errors[fieldObject][field] && (
        <MessageFormValidate error={errors[fieldObject][field].message} />
      )}
    </React.Fragment>
  );
};

export const generateDateFieldObject = (
  labelFrom,
  labelTo,
  isRequire,
  errors,
  fieldObject,
  field,
  placeholder,
  disabled,
  control,
  options
) => {
  return (
    <React.Fragment>
      <Label htmlFor={`${fieldObject}.${field}`}>
        {labelFrom}
        {labelFrom && isRequire && <span className="text-danger"> (*)</span>}
        {labelTo && `- ${labelTo}`}
        {labelTo && isRequire && <span className="text-danger"> (*)</span>}
      </Label>
      <Controller
        control={control}
        name={`${fieldObject}.${field}`}
        render={({ field }) => (
          <Flatpickr
            {...field}
            disabled={disabled}
            className="form-control d-block Flatpickr__Input"
            placeholder={disabled ? "" : placeholder}
            options={options}
          />
        )}
      />
      {errors[fieldObject] && errors[fieldObject][field] && (
        <MessageFormValidate error={errors[fieldObject][field].message} />
      )}
    </React.Fragment>
  );
};

//Check show/hide with page view
const checkShowWithPageView = (item, pageView) => {
  if (item.isShowWithPageView && item.isShowWithPageView.length > 0) {
    if (item.isShowWithPageView.findIndex(i => i === pageView) === -1) {
      return false;
    }
    return true;
  } else {
    return true;
  }
};

export const loopGenerateField = (
  item,
  label,
  placeholder,
  errors,
  touchedFields,
  register,
  control,
  OPTION_GROUP,
  optionDateLocale,
  customFormClass = "",
  onChangeHandle,
  pageView,
  extraComponent,
  disableForm = false,
  isNotAdjustChangeInfo = true,
  invoiceSymbolList = [],
  khhdonDefault = ""
) => {
  let isNotAdjustChangeInfoFlag = true;
  if (item.isHide) {
    if (item.isShowWithPageView && item.isShowWithPageView.length > 0) {
      if (item.isShowWithPageView.findIndex(item => item === pageView) === -1) {
        return "";
      }
    } else {
      return "";
    }
  } else if (!checkShowWithPageView(item, pageView)) {
    return "";
  }
  switch (item.type) {
    case "checkbox":
      return (
        <Col
          key={item.field}
          className="send_mail_col"
          style={{ display: "flex", alignItems: "center" }}
        >
          <FormGroup style={{ display: "flex", alignItems: "center" }}>
            <React.Fragment>
              <br></br>
              <Controller
                control={control}
                name={`send_mail`}
                render={({ field }) => (
                  <Input
                    key={field.value}
                    type="checkbox"
                    disabled={disableForm}
                    id="checkbox_sendmail"
                    defaultChecked={field.value}
                    className="custom-control-input checkbox-sendmail"
                    style={{ width: "20px", height: "20px", marginTop: 0 }}
                    {...register(`${item.field}`)}
                    onChange={v => {
                      onChangeHandle &&
                        onChangeHandle(v.target.checked, item.field);
                    }}
                  />
                )}
              />
              <label
                style={{ marginLeft: "10px", marginBottom: 0 }}
                htmlFor="checkbox_sendmail"
              >
                Gửi thông tin đến thư điện tử này
              </label>
            </React.Fragment>
          </FormGroup>
        </Col>
      );
    case "text":
    case "number":
      // Điều chỉnh thông tin chỉ cho thay đổi tên đơn vị và địa chỉ
      if (item.field === "nmua_ten" || item.field === "nmua_dchi") {
        isNotAdjustChangeInfoFlag = isNotAdjustChangeInfo;
      }
      return (
        <Col key={item.field}>
          <FormGroup
            className={`mb-2 ${customFormClass}`}
            style={{ width: item.width }}
          >
            {generateInputField(
              label,
              item.required,
              item.type,
              errors,
              touchedFields,
              item.field,
              placeholder,
              register,
              item.disabled || (disableForm && isNotAdjustChangeInfoFlag),
              item.widthLabel,
              control,
              item.isThousandSeparator,
              item.isTaxCode,
              item.allowNegative,
              onChangeHandle,
              extraComponent,
              item.isKHHD,
              invoiceSymbolList,
              khhdonDefault
            )}
          </FormGroup>
        </Col>
      );
    case "select":
      return (
        <Col key={item.field}>
          <FormGroup className="mb-2">
            {generateSelectField(
              label,
              item.required,
              errors,
              item.field,
              placeholder,
              item.disabled || disableForm,
              control,
              OPTION_GROUP[item.field],
              "auto",
              onChangeHandle
            )}
          </FormGroup>
        </Col>
      );
    case "date":
      return (
        <Col key={item.field}>
          <FormGroup className="mb-2">
            {generateDateField(
              label,
              "",
              item.required,
              errors,
              item.field,
              "DD/MM/YYYY",
              item.disabled || disableForm,
              control,
              optionDateLocale
            )}
          </FormGroup>
        </Col>
      );
    default:
      break;
  }
};

//
//type :raw ,tct-response ,signed
export const getResourceIdXML = (resource_list, type, mltdiep = null) => {
  //   console.log(
  //     "🚀 ~ file: form_helper.js ~ line 883 ~ getResourceIdXML ~ resource_list",
  //     resource_list
  //   );
  let resource = null;
  if (type === "tct-response") {
    // If k có mltdiep thì lấy id cuối
    if (mltdiep === null) {
      resource = resource_list
        .sort((a, b) => b.id - a.id)
        .find(item => item.type === type);
    } else {
      resource = resource_list.find(
        item => item.type === type && item.mltdiep === mltdiep
      );
    }
    if (!resource) {
      resource = resource_list
        .sort((a, b) => b.id - a.id)
        .find(item => item.type === "signed");
    }
  } else {
    resource = resource_list
      .sort((a, b) => b.id - a.id)
      .find(item => item.type === type);
  }
  //   console.log(
  //     "🚀 ~ file: form_helper.js ~ line 883 ~ getResourceIdXML ~ resource_list",
  //     resource
  //   );
  return resource ? resource.id : null;
};
